import type { ProcessReferenceDataItem } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { MissingChip, ProcessChip } from "~/components/Chips";
import { MultiSelect } from "~/components/MultiSelect/MultiSelect";
import type { FocusableComponent } from "~/components/VirtualListWithKeyboard/FocusableComponent";
import type { Item } from "~/components/VirtualListWithKeyboard/VirtualListWithKeyboard";
import type { FormFieldProps } from "~/components/form";
import type { ComponentProps } from "~/utils/types/MappedTypes";
import Lookup from "../Lookup";
const ProcessTypedMultiSelect = MultiSelect<ProcessReferenceDataItem>();
type RenderChip = ComponentProps<typeof ProcessTypedMultiSelect>["renderChip"];
interface ProcessMultiSelectProps extends FormFieldProps<string[]> {
    items: ProcessReferenceDataItem[];
    openOnFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
    hideFloatingLabel?: boolean;
    multiSelectRef?(component: FocusableComponent | null): void;
}
const ProcessMultiSelect: React.FC<ProcessMultiSelectProps> = (props) => {
    const chipRenderer: RenderChip = React.useCallback((r, onRequestDelete: () => void) => {
        return (<Lookup lookupCollection={props.items} lookupId={r.Id} getIdFromElement={(element) => element.Id} render={(item) => <ProcessChip processType={item.ProcessType} onRequestDelete={onRequestDelete} deleteButtonAccessibleName={`Delete ${r.Name}`} name={r.Name}/>} renderFallback={<MissingChip lookupId={r.Id} deleteButtonAccessibleName={"Delete Missing Resource"} onRequestDelete={onRequestDelete}/>}/>);
    }, [props.items]);
    const itemRender = React.useCallback((r: ProcessReferenceDataItem): Item => ({ primaryText: r.Name, secondaryText: r.ProcessType }), []);
    return <ProcessTypedMultiSelect renderItem={itemRender} fieldName="processes" renderChip={chipRenderer} {...props}/>;
};
ProcessMultiSelect.displayName = "ProcessMultiSelect"
export default ProcessMultiSelect;
